export default __webpack_public_path__ + "static/gabrielaj-76e4a92827dd879e7d4aaf6a7042585d.png";